import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import { H2 } from '@atlassian/amkt-common';
import { LinkUtils } from '@atlassian/mpac-utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ScreenClassRender } from 'react-grid-system';

import CommonPropTypes from '../../../../../../../../constants/PropTypes';

import solutionStyles from '../Solution.less';
import styles from './SolutionBodyTopSection.less';

export default class SolutionBodyTopSection extends Component {
  static propTypes = {
    addonDiscoveryConfig: CommonPropTypes.addonDiscoveryConfig.isRequired,
    breadcrumbText: PropTypes.string.isRequired,
    history: CommonPropTypes.history.isRequired,
    path: PropTypes.string.isRequired,
    primaryDescription: PropTypes.string.isRequired,
    tagline: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={styles.solutionBodyTopSection}>
        <div className={solutionStyles.solutionContainer}>
          <ScreenClassRender render={this.renderBreadcrumb}>
            <span />
          </ScreenClassRender>
        </div>
        <div className={`${styles.contentContainer} ${solutionStyles.solutionTopContainer}`}>
          <div>
            {/* @ts-expect-error [MC-2850] - TS2339 - Property 'tagline' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'. */}
            <H2 className={styles.heading}>{this.props.tagline}</H2>
          </div>
          {/* @ts-expect-error [MC-2850] - TS2339 - Property 'primaryDescription' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'. */}
          <div className={styles.primaryDescription}>{this.props.primaryDescription}</div>
        </div>
      </div>
    );
  }

  onBreadcrumbItemClick = (href: any) => (e: any) => {
    LinkUtils.maybeOpenInNewTab(e, () => {
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'. | TS2304 - Cannot find name 'href'.
      this.props.history.push({ pathname: href });
    });
  };

  renderBreadcrumb = (sc: any) => {
    let paths = [
      {
        // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
        href: this.props.addonDiscoveryConfig.links.home.href,
        key: 'marketplace',
        text: 'Marketplace',
      },
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
      { href: this.props.path, key: 'breadcrumbText', text: this.props.breadcrumbText },
    ];

    if (sc === 'xs') {
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
      paths = paths.filter((path) => path.href === this.props.addonDiscoveryConfig.links.home.href);
    }

    return (
      <Breadcrumbs>
        {paths.map((path) => (
          <BreadcrumbsItem
            href={path.href}
            key={path.key}
            onClick={this.onBreadcrumbItemClick(path.href)}
            text={path.text}
          />
        ))}
      </Breadcrumbs>
    );
  };
}
